import {Outlet} from "react-router-dom";
import {useMemo} from "react";
import {Colors} from "@bounce/shared/ui";
import {AccountMain, AccountRoot} from "@bounce/shared/consumer/helpers";
import {usePartnerUi} from "~/contexts/PartnerUiContext";
import {useUiSettings} from "~/hooks";
import {useDocumentMeta} from "@bounce/shared/hooks";
import {urls} from "~/routes/consumerUrls";
import {Webchat} from "~/components/webchat/WebchatProvider";
import {NewDesignLayout} from "~/new-design/layout";
import AccountFooter from "./AccountFooter";
import AccountHeader from "./AccountHeader";

const AccountLayout = () => {
  const {whiteLabelEnabled, partnerDetails} = usePartnerUi();
  const {uiSettings} = useUiSettings();

  const name = useMemo(() => {
    if (whiteLabelEnabled) return partnerDetails?.partnerName || "";
    return uiSettings?.partner_name || "";
  }, [whiteLabelEnabled, partnerDetails, uiSettings]);

  useDocumentMeta({urls, favicon: "/favicon-bounce.ico", titleSuffix: name});

  if (whiteLabelEnabled) {
    return (
      <AccountRoot>
        <Webchat />
        <div style={{flexGrow: 1, backgroundColor: Colors.tertiary._100}}>
          <AccountHeader />
          <AccountMain>
            <Outlet />
          </AccountMain>
        </div>
        <AccountFooter />
      </AccountRoot>
    );
  }

  return (
    <NewDesignLayout>
      <Webchat />
      <Outlet />
    </NewDesignLayout>
  );
};

export default AccountLayout;
